import React from "react"

import PortfolioConditionForm from "./portfolio-condition-form"
import ProjectsListManager from "../../../gd/manager/projects-list-manager"
import {SystemStatusGroup} from "../../../gd/const/system-status";
import {PortfolioConditionType} from "./@const";

// const debug = "PortfolioCondition"
const debug = false

export default class PortfolioCondition {

    public type                     : PortfolioConditionType = PortfolioConditionType.MANUAL

    public projectIds               : ID []
    public projectTypes             : ID []
    public parentProjectIds         : ID []
    public systemStatusesGroup      : SystemStatusGroup

    constructor(settings:any) {

        this.projectIds             = _.get(settings, 'projectIds', [])
        this.projectTypes           = _.get(settings, 'projectTypes', [])
        this.parentProjectIds       = _.get(settings, 'parentProjectIds', [])
        this.systemStatusesGroup    = _.get(settings, 'systemStatusesGroup', SystemStatusGroup.ALL)

        if (!_.isEmpty(this.projectIds))            this.type = PortfolioConditionType.MANUAL
        if (!_.isEmpty(this.projectTypes))          this.type = PortfolioConditionType.PROJECT_TYPES
        if (!_.isEmpty(this.parentProjectIds))      this.type = PortfolioConditionType.ALL_IN_PARENTS

        debug && console.log(debug, "constructor", settings, this)
    }

    changeType = (value:any) => {
        this.type = value
    }

    onProjectsChanged = (value:ID[]) => {
        this.projectIds = value
    }

    onProjectTypesChanged = (value:ID[]) => {
        this.projectTypes = value
    }

    onParentProjectIdsChanged = (value:ID[]) => {
        this.parentProjectIds = value
    }

    onProjectsStatusChanged = (value: SystemStatusGroup) => {
        this.systemStatusesGroup = value
    }

    getProjects = ():ID[] => {
        debug && console.log(debug, "getProjects", this.type)

        let res : ID[] = []

        switch (this.type) {

            case PortfolioConditionType.ALL_IN_PARENTS:
                // calculate by condition
                // + tree parent only (sprint vnutri subsprint return paret sprint only)
                // - folder ETO NE TYPE !!!

                _.map(this.parentProjectIds, (parentProjectId:ID)=>{
                    const childrenProjects = ProjectsListManager.getChildProjects(gd.companyId, parentProjectId, 'name', true)

                    _.map(childrenProjects, (projectData:any)=>{
                        const project = gd.session.projects.get(projectData.id)
                        if (project) {
                            res.push(project.id)
                        }
                    })

                })
                break

            case PortfolioConditionType.PROJECT_TYPES:
                // calculate by condition
                // + tree parent only (sprint vnutri subsprint return paret sprint only)
                // - folder ETO NE TYPE !!!

                if (!_.isEmpty(this.projectTypes)) {
                    const rootProjects = ProjectsListManager.getChildProjects(gd.companyId, null, 'name', true)

                    debug && console.log(debug, "getProjects", this.projectTypes)

                    const processProject = (projectId:ID) => {
                        const sessionProject = gd.session.projects.get(projectId)!
                        debug && console.log(debug, "processProject", this.projectTypes.includes(sessionProject.localTemplateId!), sessionProject.localTemplateId, sessionProject)

                        if (this.projectTypes.includes(sessionProject.localTemplateId!)) res.push(sessionProject.id) // add project if it is of searched type
                        else recursiveCollectChildren(sessionProject.id)                                            // otherwise search among its children
                    }

                    const recursiveCollectChildren = (projectId:ID)=>ProjectsListManager.getChildProjects(gd.companyId, projectId).map(c=>processProject(c.id))

                    _.map(rootProjects, project=>processProject(project.id))
                }
                break

            case PortfolioConditionType.MANUAL:
                res = this.projectIds
                break
        }

        debug && console.log(debug, "getProjects res", res)

        return res
    }

    // visual
    renderForm = (form:any, disabled?:boolean) => {
        return <PortfolioConditionForm type                     = {this.type}
                                       form                     = {form}
                                       disabled                 = {disabled}
                                       parent                   = {this}
                                       onTypeChanged            = {this.changeType}
                                       onProjectsChanged        = {this.onProjectsChanged}
                                       onProjectTypesChanged    = {this.onProjectTypesChanged}
                                       onProjectsStatusChanged  = {this.onProjectsStatusChanged}/>
    }

    // methods for manual project ids
    addProject      = (projectId:ID) => {
        this.projectIds.push(projectId)
    }

    removeProject   = (projectId:ID) => {
        _.remove(this.projectIds, id=>id === projectId)
    }

    toJSON = () => {
        let settings : any = {}

        switch (this.type) {
            case PortfolioConditionType.ALL_IN_PARENTS:
                settings.parentProjectIds   = this.parentProjectIds
                settings.systemStatusesGroup = this.systemStatusesGroup
                break

            case PortfolioConditionType.PROJECT_TYPES:
                settings.projectTypes   = this.projectTypes
                settings.systemStatusesGroup = this.systemStatusesGroup
                break

            case PortfolioConditionType.MANUAL:
                settings.projectIds     = this.projectIds
                break
        }

        return settings
    }
}
